/* @section: sectors-tasks-data */
import type { Sector, TaskDef } from "./types";

export const SECTORS: Sector[] = [
  {
    id: "commerce",
    label: "Commerce & Vente",
    icon: "ShoppingCart",
    description: "Suivi des ventes, stocks, clients et performances commerciales.",
  },
  {
    id: "rh",
    label: "RH & Administration",
    icon: "Users",
    description: "Gestion des employés, congés, paie et suivi administratif.",
  },
  {
    id: "btp",
    label: "BTP & Chantiers",
    icon: "HardHat",
    description: "Suivi de chantier, devis travaux et gestion des matériaux.",
  },
  {
    id: "autre",
    label: "Autre secteur",
    icon: "Sparkles",
    description: "Décrivez librement votre besoin, l'outil s'adapte.",
  },
];

export const TASKS_BY_SECTOR: Record<string, TaskDef[]> = {
  commerce: [
    { id: "suivi-ventes", label: "Suivi des ventes", description: "Tableau de suivi des ventes avec CA et marges." },
    { id: "gestion-stocks", label: "Gestion des stocks", description: "Inventaire avec quantités, seuils et valorisation." },
    { id: "tableau-clients", label: "Tableau de bord clients", description: "Fiche clients avec historique et chiffre d'affaires." },
  ],
  rh: [
    { id: "planning-conges", label: "Planning des congés", description: "Suivi des demandes et soldes de congés." },
    { id: "suivi-employes", label: "Suivi des employés", description: "Registre du personnel avec postes et contrats." },
    { id: "fiche-paie", label: "Fiche de paie", description: "Calcul de salaire brut/net avec cotisations." },
  ],
  btp: [
    { id: "suivi-chantier", label: "Suivi de chantier", description: "Avancement des tâches, dates et responsables." },
    { id: "devis-travaux", label: "Devis travaux", description: "Devis détaillé avec quantités, prix et totaux." },
    { id: "gestion-materiaux", label: "Gestion des matériaux", description: "Suivi des matériaux, quantités et coûts." },
  ],
  autre: [
    { id: "tableau-generique", label: "Tableau personnalisé", description: "Tableau de gestion générique adaptable au prompt." },
    { id: "budget", label: "Suivi de budget", description: "Suivi des dépenses et recettes avec solde." },
    { id: "planning", label: "Planning / Tâches", description: "Liste de tâches avec échéances et statuts." },
  ],
};
